/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line no-shadow
export var ServiceNames;
(function (ServiceNames) {
    ServiceNames["File"] = "FileService";
    ServiceNames["Order"] = "OrderService";
    ServiceNames["ServiceTask"] = "ServiceTaskService";
    ServiceNames["ConditionIssue"] = "ConditionIssueService";
    ServiceNames["Asset"] = "AssetService";
    ServiceNames["Command"] = "CommandService";
    ServiceNames["CommandRegistry"] = "CommandRegistryService";
    ServiceNames["Storage"] = "StorageService";
})(ServiceNames || (ServiceNames = {}));
